import { render, staticRenderFns } from "./postView.vue?vue&type=template&id=a57e12f2&scoped=true"
import script from "./postView.vue?vue&type=script&lang=js"
export * from "./postView.vue?vue&type=script&lang=js"
import style0 from "./postView.vue?vue&type=style&index=0&id=a57e12f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57e12f2",
  null
  
)

export default component.exports